/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import Badge from '@tencent/dui/lib/components/Badge';
import { network } from '@tencent/netcheck';
import styles from './index.css';
import TemplateImportMenu from './menu/template-import-menu';
import Dropdown from '@com-pc/dropdown';
import classNames from 'classnames';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '../../../../slide/infrastructure/module/dependent/report/offline-data-report/constant';
import i18n from '@i18next/i18n';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { INSERT_SLIDE_ORIGIN_TYPE } from '@src/js/constant';
import appConfigInstance, { setDefaultConfig } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { getToggleStatusByType, ToggleType } from '@src/slide/infrastructure/module/dependent/config/toggle-config';
import { AddOrRemoveSlide } from '@src/framework/frame/components/tool-bar/add-or-remove-slide';
import { CLICK_FROM } from '@src/framework/workbench/ui/constant';
import { AddTemplatePanel } from '@src/framework/frame-pc/components/add-template-panel';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import userLocalStorage, { LocalStorageKeys } from '@src/slide/infrastructure/module/independent/local-storage';
import Menu from '@tencent/dui/lib/components/Menu';
import createFromTemplateIcon from '@tencent/docs-design-resources/icon/desktop/svg/templates_outline_light_24.svg';
import createFromFormatIcon from '@tencent/docs-design-resources/icon/desktop/svg/format_outline_light_24.svg';
import aiGenerateSlideIcon from '@tencent/docs-design-resources/icon/desktop/svg/ai_summarize_light_24.svg';
import { RECOMMEND_TAB_IDS } from '@com/tool-bar/toolbar-grid-menu.interface';
import { AiFloatReportPlace } from '@src/slide/application/service/ai-float-manager/index.interface';
import DocsConfig from '@tencent/docs-config';

interface ToolbarItemTemplateProps {
    disabled: boolean;
    id: string;
    dropdown: {
        dropIcon: string;
    };
    onOnlineClick: () => void;
}

interface ToolbarItemTemplateState {
    showRedPoint: boolean;
    importOfflineDisabled: boolean;
    activeTabIdOfTemplate: RECOMMEND_TAB_IDS;
    activeTabIdOfFormat: RECOMMEND_TAB_IDS;
}

const SLIDE_ADD_PAGE_DROPDOWN_ID = 'slideAddPageDropdown'; // 2023-12-15 00:00:00  过期删除
const ENABLE_AI_PAGE_GENERATE = (
    (DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.aiGeneratePage) ?? false)
    && (getToggleStatusByType(ToggleType.AI_FLOAT_BAR) ?? true)
);

export default class ToolbarItemTemplate extends Component<ToolbarItemTemplateProps, ToolbarItemTemplateState> {
    private addOrRemoveSlide: AddOrRemoveSlide;
    private importDropDom: any;
    private dropDom: any;
    public constructor(props: ToolbarItemTemplateProps, context: any) {
        super(props, context);
        this.state = {
            showRedPoint: this.getInitRedPointShowState(),
            importOfflineDisabled: !network.isOnline,
            activeTabIdOfTemplate: RECOMMEND_TAB_IDS.TEXT,
            activeTabIdOfFormat: RECOMMEND_TAB_IDS.BASE,
        };
        this.addOrRemoveSlide = new AddOrRemoveSlide();
    }
    public render() {
        const { disabled, id, dropdown } = this.props;
        const { importOfflineDisabled, activeTabIdOfTemplate, activeTabIdOfFormat  } = this.state;
        const importDisabled = disabled || importOfflineDisabled;
        const enableImportFile = setDefaultConfig(
            appConfigInstance.getConfig(ToolbarFileMenuConfig.importFile as any),
            true,
        );
        const addSlideClass = classNames({
            [styles.addSlideDiv]: true,
            [styles.addSlideDisable]: disabled,
        });

        const dropIconClass = classNames({
            [styles.dropIconDiv]: true,
            [styles.addSlideDisable]: disabled,
        });

        const importSlideDivClass = classNames({
            [styles.importSlideDiv]: true,
            [styles.addSlideDisable]: importDisabled,
        });

        const addPageContainerStyles: React.CSSProperties = {
            cursor: 'default',
        };
        if (!enableImportFile) {
            addPageContainerStyles.width = '100%';
        }

        return (
            <div className={styles.addSlideContainer}>
                <div className={styles.leftContainer} style={addPageContainerStyles} onClick={this.handleAddSlideClick}>
                    <div className={addSlideClass}>
                        {i18n.t('添加页面')}
                    </div>
                    <div className={dropIconClass} id={`toolbar-${id}`}
                        style={{ cursor: disabled ? 'default' : 'pointer' }} onClick={e => e.stopPropagation()}>
                        {this.state.showRedPoint ? (
                            <Badge dot offsetY={6} className={styles['add-page-red-point-container']}>
                                <img
                                    className={styles.templateDropIcon}
                                    src={dropdown.dropIcon}
                                    style={disabled ? { opacity: 0.4 } : undefined}
                                />
                            </Badge>
                        ) : (
                            <img
                                className={styles.templateDropIcon}
                                src={dropdown.dropIcon}
                                style={disabled ? { opacity: 0.4 } : undefined}
                            />
                        )}
                        <Dropdown
                            belongID={`toolbar-${id}`}
                            hasShadow={false}
                            ref={(ref) => {
                                this.dropDom = ref;
                            }}
                            disabled={disabled}
                            scrollable={false}
                            offsetX={-66}
                            onVisibleChange={this.onVisibleChange}
                        >
                            <Menu itemStyle={{ paddingLeft: '9px', paddingRight: '9px' }}>
                                <Menu.SubMenu
                                    title={i18n.t('从模板新建')}
                                    icon={createFromTemplateIcon}
                                    onVisibleChange={(visible: boolean) => {
                                        if (visible) {
                                            this.setState({ activeTabIdOfTemplate: RECOMMEND_TAB_IDS.TEXT });
                                            // 上报添加页面 - 从模板新建
                                            this.reportAddPage(TDWActionType.MORE_TEMPLATE);
                                        }
                                    }}
                                >
                                    <AddTemplatePanel
                                        id='add-template-panel-text'
                                        onDropContentClick={() => {
                                            this.dropDom?.stopHiding();
                                        }}
                                        hideDropDownCb={this.hideDropDown}
                                        clickFrom={CLICK_FROM.LEFTBAR}
                                        activeTabId={activeTabIdOfTemplate}
                                        onTabChange={(tabId) => {
                                            this.setState({ activeTabIdOfTemplate: tabId });
                                            // 上报添加页面 - 从版式新建
                                            this.reportAddPage(TDWActionType.MORE_FORMAT);
                                        }}
                                    />
                                </Menu.SubMenu>
                                <Menu.SubMenu
                                    title={i18n.t('从版式新建')}
                                    icon={createFromFormatIcon}
                                    onVisibleChange={(visible: boolean) => {
                                        if (visible) {
                                            this.setState({ activeTabIdOfFormat: RECOMMEND_TAB_IDS.BASE });
                                        }
                                    }}
                                >
                                    <AddTemplatePanel
                                        id='add-template-panel-base'
                                        onDropContentClick={() => {
                                            this.dropDom?.stopHiding();
                                        }}
                                        hideDropDownCb={this.hideDropDown}
                                        clickFrom={CLICK_FROM.LEFTBAR}
                                        activeTabId={activeTabIdOfFormat}
                                        onTabChange={(tabId) => {
                                            this.setState({ activeTabIdOfFormat: tabId });
                                        }}
                                    />
                                </Menu.SubMenu>
                                {
                                    ENABLE_AI_PAGE_GENERATE
                                    && <Menu.Item icon={aiGenerateSlideIcon} onClick={this.handleAiGenerateSlide}>{i18n.t('AI生成页')}</Menu.Item>
                                }
                            </Menu>
                        </Dropdown>
                    </div>
                </div>
                {enableImportFile && (
                    <>
                        <div className={styles.divider}/>
                        <div className={importSlideDivClass} onClick={this.onImportDropButtonClick}
                            id={`toolbar-import-${id}`}>
                            {i18n.t('导入')}
                        </div>
                        <Dropdown
                            belongID={`toolbar-import-${id}`}
                            hasShadow={false}
                            ref={(ref) => {
                                this.importDropDom = ref;
                            }}
                            disabled={importDisabled}
                            scrollable={false}
                        >
                            <TemplateImportMenu
                                onOnlineClick={this.props.onOnlineClick}
                                handleClickCB={this.hideImportDropDown}
                            />
                        </Dropdown>
                    </>
                )}
            </div>
        );
    }

    public componentDidMount() {
        network.changeEnd((status) => {
            this.setState({
                importOfflineDisabled: status === 'offline',
            });
        });
    }

    // 红点引导，2023-12-15 00:00:00  过期删除
    private getInitRedPointShowState = (): boolean => {
        const enableShowRedPoint = getToggleStatusByType(ToggleType.SLIDE_ADD_PAGE_RED_POINT, false);
        if (!enableShowRedPoint) {
            return false;
        }
        return !userLocalStorage.getItem(LocalStorageKeys.SLIDE_ADD_PAGE_DROPDOWN);
    };

    private handleAddSlideClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!this.props.disabled) {
            this.addOrRemoveSlide.addPcBlankSlide();
            e.stopPropagation();

            // 上报 直接添加页面成功
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_EDIT_LIST,
                action: TDWActionType.ADD_SUC,
            });
        }
    };

    private hideImportDropDown = () => {
        if (this.importDropDom) {
            this.importDropDom.hide();
        }
    };

    private onVisibleChange = (visible: boolean) => {
        if (visible) {
            // 上报 幻灯片列表-添加页面选择版式按钮点击
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_EDIT_LIST,
                action: TDWActionType.CLK_TEMPLATE,
            });
            // 上报 添加页面-点击更多菜单
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.ADD_PAGE,
                action: TDWActionType.MORE_CLICK,
            });
            if (this.state.showRedPoint) {
                this.setState({
                    showRedPoint: false,
                });
                userLocalStorage.setItem(LocalStorageKeys.SLIDE_ADD_PAGE_DROPDOWN, true);
            }
        }
        const menuManager = this.getMenuManager();
        if (menuManager) {
            menuManager.isDropdownShown = visible;
        }
    };

    private onImportDropButtonClick = () => {
    // 上报 幻灯片列表-添加页面-导入
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.INSERT_SLIDE_ENTRY,
            action: TDWActionType.INSERT_SLIDE_ENTRY_CLICK,
            ver5: INSERT_SLIDE_ORIGIN_TYPE.LEFT_TOP,
        });
    };

    private getMenuManager() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.menuManager;
    }

    private hideDropDown = () => {
        this.dropDom?.hide();
    };

    private handleAiGenerateSlide = () => {
        const appService = (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices);
        const aiFloatManager = appService?.editableServiceLayer?.aiFloatManager;
        aiFloatManager?.triggerGeneratePage({});

        // 上报添加页面 - AI生成页
        this.reportAddPage(TDWActionType.MORE_AI);
        // 上报生成页
        tdw({
            opername: TDWOperationType.DOC_PPT_AI,
            module: TDWModuleType.PAGE_CREATE,
            action: TDWActionType.CLICK,
            ver5: TDWModuleType.PC,
            ver6: AiFloatReportPlace.thumbnail,
        });

        this.hideDropDown();
    };

    private reportAddPage = (action: string) => {
        if (!action) return;
        // 上报添加页面
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.ADD_PAGE,
            action,
        });
    };
}
